export default "__VITE_PUBLIC_ASSET__8e53bc51__"